import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-game-card',
  templateUrl: './game-card.component.html',
  styleUrls: ['./game-card.component.scss'],
})
export class GameCardComponent implements OnChanges {
  @Input() game: any = null;
  @Output() onDelete = new EventEmitter<any>();
  @Output() onToggleActive = new EventEmitter<any>();

  public gameImg: string = 'assets/img/groups/icons/list.png';
  public displayName: string = '';
  public displayDescription: string = '';

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.game) return;

    const data = this.game.data_json || {};
    const lang = data['english'] || data['dutch'] || data['spanish'] || Object.values(data)[0] || {};
    this.displayName = (lang as any).name || this.game.identifier || '';
    this.displayDescription = (lang as any).description || '';
    this.gameImg = (lang as any).hero_image || this.game.image || 'assets/img/groups/icons/list.png';
  }

  public editGame() {
    this.router.navigate(['/admin/game/edit', this.game.id]);
  }
}
